import React, { Fragment } from "react";
import { styled } from '@mui/material/styles';
import heroStyles from './HeroStyles';

export default function Hero() {
  return (
    <section>
      <div className="flex justify-center">
        <div className="my-[15rem] md:my-[15rem] lg:my-[20rem] text-2xl md:text-[4rem] lg:text-[8rem] font-bold text-center leading-[3.5rem] lg:leading-[8rem]">
          Catalogo en construcción...
        </div>
      </div>
    </section>
  )
}
